import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ValidatorFn, AbstractControl, FormControl } from '@angular/forms';
import { UserService } from '../../services/user.service';
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styles: []
})
export class EditProfileComponent implements OnInit {

  editProfileForm: FormGroup;

  constructor(private formBuilder: FormBuilder,
    private userService: UserService, private dialogfRef: MatDialogRef<EditProfileComponent>,
    private snackBar: MatSnackBar, @Inject(MAT_DIALOG_DATA) private data:any) {


    this.editProfileForm = this.formBuilder.group({
      username: [this.data.currentUser.name, [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      cellphone: ['', [Validators.required, Validators.pattern('^0[0-9]{9}')]], /* regex this */
    });
  }


  ngOnInit() {
    this.username.disable();
  }



  saveEditUser() {
    var user = {
      name: this.username.value,
      email: this.email.value,
      cellphone: this.cellphone.value,
      roles: ['ROLE_ADMIN'],
    }

    this.userService.editUserDetails(user)
      .subscribe(res => {
        if (res.success.length != 0) {
          console.log('sdsdsdsd', res)
        this.dialogfRef.close(true);
        this.snackBar.open('User edited', 'success', {duration:4000})
      
        }
        else {      
          this.dialogfRef.close();
          this.snackBar.open('operation failed', 'error', {duration:5000})
          this.userService.getUsers();
        }
      });

  }


  get username() {
    return this.editProfileForm.get('username');
  }

  get email() {
    return this.editProfileForm.get('email');
  }

  get cellphone() {
    return this.editProfileForm.get('cellphone');
  }

}